import { render, staticRenderFns } from "./wyTable.vue?vue&type=template&id=06ca729a&scoped=true"
import script from "./wyTable.vue?vue&type=script&lang=js"
export * from "./wyTable.vue?vue&type=script&lang=js"
import style0 from "./wyTable.vue?vue&type=style&index=0&id=06ca729a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca729a",
  null
  
)

export default component.exports